export const ACCOUNT_SESSION_EVENT_CHANNEL = "cfmoto_account_session_changes";
export const ACCOUNT_SESSION_ENDED_EVENT = "cfmoto:account-session-ended";
export type AccountSessionEndReason = "session-replaced" | "session-ended" | "company-disabled" | "owner-disabled";
export type AccountSessionEnded = { userId: string; sessionId: string; reason: AccountSessionEndReason };

export function isAccountSessionEndReason(value: unknown): value is AccountSessionEndReason {
  return value === "session-replaced" || value === "session-ended" || value === "company-disabled" || value === "owner-disabled";
}

/** Internal notification, delivered only after the session transaction commits. */
export function parseAccountSessionEnded(payload: string | undefined): AccountSessionEnded | null {
  if (!payload || payload.length > 2_000) return null;
  try {
    const event = JSON.parse(payload);
    if (typeof event?.userId !== "string" || !event.userId || event.userId.length > 256 ||
      typeof event.sessionId !== "string" || !event.sessionId || event.sessionId.length > 256 ||
      !isAccountSessionEndReason(event.reason)) return null;
    return { userId: event.userId, sessionId: event.sessionId, reason: event.reason };
  } catch { return null; }
}
